import {
  BeachbumRollingOffer,
  ERollingOffersInternalViewModel,
  HugeRollingOffer,
  JunesJourneyOffer,
  MatchMastersRollingOffer,
  PlaystudiosRollingOffer,
  RoyalMatchRollingOffer,
  StudioDefaultRollingOffer
} from '@appcharge/shared-ui';

import { ETemplateStudioLayoutOptions, EThemes } from '../enums';

import { RollingOffersDesignsMetadata } from './types';

const duo: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.STUDIO_DEFAULT,
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: 'Duo Offer',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/default_rolling_offers.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: StudioDefaultRollingOffer
};

const defaultHuuuge: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.HUGE,
  theme: EThemes.HUUUGE,
  version: '1.0.0',
  name: 'Huuuge',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/rolling_offers_huuuge.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: HugeRollingOffer
};

const defaultPlaydogsoft: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.HUGE,
  theme: EThemes.PLAYDOG,
  version: '1.0.0',
  name: 'Playdog',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/rolling_offers_huuuge.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: HugeRollingOffer
};

const defaultMatchMasters: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.MATCH_MASTERS,
  theme: EThemes.CANDIVORE,
  version: '1.0.0',
  name: 'Match Masters',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: MatchMastersRollingOffer
};

const defaultJunesJourney: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.JUNES_JOURNEY,
  theme: EThemes.JUNES_JOURNEY,
  version: '1.0.0',
  name: 'Junes Journey',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/junes-journey-rolling-offer.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: JunesJourneyOffer
};

const defaultKonamiSlots: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.KONAMI_SLOTS,
  theme: EThemes.PLAYSTUDIOS,
  version: '1.0.0',
  name: 'Konami Slots',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/Playstudios/rolling-offers-konami-slots.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: PlaystudiosRollingOffer
};

const defaultRoyalMatch: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.ROYAL_MATCH,
  theme: EThemes.ROYAL_MATCH,
  version: '1.0.0',
  name: 'Royal Match',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [''],
  layout: [ETemplateStudioLayoutOptions.VERTICAL],
  component: RoyalMatchRollingOffer
};

const defaultBeachbum: RollingOffersDesignsMetadata = {
  id: ERollingOffersInternalViewModel.BEACHBUM,
  theme: EThemes.BEACHBUM,
  version: '1.0.0',
  name: 'Beachbum',
  createdAt: '2025-08-28T08:37:11.255Z',
  isPrivate: true,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/beachbum-rolling-offer.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: BeachbumRollingOffer
};

export const rollingOffersDesigns = {
  defaultHuuuge,
  defaultPlaydogsoft,
  defaultMatchMasters,
  defaultJunesJourney,
  defaultRoyalMatch,
  defaultBeachbum,
  duo,
  defaultKonamiSlots
};

export const rollingOffersDesignsByTheme: Record<
  EThemes,
  RollingOffersDesignsMetadata[]
> = Object.values(rollingOffersDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, RollingOffersDesignsMetadata[]>
);

export const rollingOffersDesignsById: Record<
  string,
  RollingOffersDesignsMetadata
> = Object.values(rollingOffersDesigns).reduce(
  (acc, design) => {
    acc[design.id] = design;
    return acc;
  },
  {} as Record<string, RollingOffersDesignsMetadata>
);
